import { defineMessages, useIntl } from 'react-intl';
import { NumberInput } from '@mantine/core';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';
import sharedMessages from 'Components/utils/sharedMessages';

const EveryMonthRecurrenceInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();

    const value = values.recurrence.monthly?.interval ?? 1;

    const updateEveryXMonth = (interval: number | string) => {
        updateValues({
            recurrence: {
                ...values.recurrence,
                monthly: {
                    ...values.recurrence.monthly,
                    interval: Number(interval) || 1,
                },
            },
        });
    };

    return (
        <div style={{ maxWidth: '200px' }}>
            <NumberInput
                id="every-month-recurrence-input"
                label={intl.formatMessage(messages.label)}
                max={12}
                min={1}
                onChange={updateEveryXMonth}
                size="md"
                step={1}
                value={value}
                radius="md"
                error={value < 1 || value > 12 ? intl.formatMessage(sharedMessages.invalidValue) : undefined}
            />
        </div>
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventRecurrence.MonthlyRecurrence.EveryMonthInput.label',
        defaultMessage: 'Co ile miesięcy?',
    },
});

export default EveryMonthRecurrenceInput;
